module.exports = __webpack_public_path__ + "img/bg_season-suites.dd08c421.jpg";